import { useMemo } from "react"
import type { CombinedError } from "urql"
import { useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import type { Instruction, InstructionSortField, Query, SortingOrder } from "@/graphql/codegen/graphql"
import { InstructionsListDocument } from "@/graphql/codegen/graphql"

interface UseInstructionsForProductListReturn {
  instructions: Instruction[]
  fetchingInstructions: boolean
  error?: CombinedError
}

const useInstructionsForProductList = ({
  query,
  instructionId,
  isActive = true,
  pause,
  sort,
}: {
  query?: string
  instructionId?: number
  isActive?: boolean
  pause?: boolean
  sort?: {
    field: InstructionSortField
    order: SortingOrder
  }
}): UseInstructionsForProductListReturn => {
  const [{ error, data, fetching }] = useQuery<Pick<Query, "instruction">>({
    query: InstructionsListDocument,
    variables: {
      input: {
        filter: {
          query,
          instructionId,
          isActive,
        },
        offset: 0,
        limit: FULL_LIST_LIMIT,
        sort,
      },
    },
    pause,
  })

  const instructions = useMemo(() => {
    if (data?.instruction?.list?.__typename === "InstructionListSuccess") {
      return data?.instruction?.list?.instructions as Instruction[]
    }
    return []
  }, [data])

  return {
    instructions,
    fetchingInstructions: fetching,
    error,
  }
}

export default useInstructionsForProductList
